export enum Services {
    Central = 'Central',
    CRM = 'CRM',
    Sign = 'Sign',
    Pay = 'Pay',
    Voice = 'Voice',
    Consent = 'Consent',
    Campaign = 'Campaign',
    Connect = 'Connect',
    Desk = 'Desk',
    Lead='Lead'
}